import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./subscription.css";
import Switch from "react-switch";
import { UtilityFunctions } from "../../../utils/UtilityFunctions";
import PaymentProcedure from "./PaymentProcedure";
import { api } from "../../../middleware/api";
import ValidationErrorToast from "../../../components/validationErrorToast";
import { userService } from "../../../_services/user.service";
import { cookieService } from "../../../_services/cookie.service";

const SubscriptionModalAccounts = (props: any) => {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isPlanSelected, setIsPlanSelected] = useState(null);
  const [isCardAdded, setIsCardAdded] = useState(false);
  const [productId, setProductId] = useState("prod_SGyNKbYSAVVBT7");
  const [subscriptionStep, setSubscriptionStep] = useState(1);
  const [couponCodeValue, setCouponCodeValue] = useState("");
  const [promoData, setPromoData] = useState<any>();
  const [showSpecialDiscount, setShowSpecialDiscount] = useState(false);
  const [specialDiscountAmount, setSpecialDiscountAmount] = useState<any>();
  const [specialDiscountSource, setSpecialDiscountSource] = useState<any>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Determine whitelabel from hostname, not async config
  const hostname = window.location.hostname;
  const isWhitelabel = hostname !== 'localhost' && !hostname.includes('mploi.com');

  // Use whitelabel price text if available, otherwise fallback
  const [specificPrice, setSpecificPrice] = useState<any>(isWhitelabel ? '' : '$416 / month + GST');

  const getProductInfoForCode = () => {
    api.get(`subscription/code-detail/?code=${localStorage.getItem("referralCode")}`, {
      "product_id": localStorage.getItem("referralCode"),
    }).then((data) => {
      if (data) {
        setSpecificPrice(data.priceText);
        setProductId(data.productId);

        if (data.saving > 0) {
          setShowSpecialDiscount(true);
          setSpecialDiscountAmount(data.saving);
          setSpecialDiscountSource(data.code);
        }

        setSubscriptionStep(2);
      }
    })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const handlePaymentOption = () => {
    handleCreateSubscription()
  }

  useEffect(() => {
    if (!isWhitelabel) {
      setProductId('prod_SGyNKbYSAVVBT7');
    }
    setSubscriptionStep(2);
  }, [props.subsModal])

  useEffect(() => {
    // Update price text when stripeConfig loads
    if (props.stripeConfig?.monthly_price_text) {
      setSpecificPrice(props.stripeConfig.monthly_price_text);
    } else if (props.stripeConfig?.monthly_price_id && !specificPrice) {
      setSpecificPrice('Monthly subscription');
    }
  }, [props.stripeConfig]);

  const handlePayment = () => {
    if (isPlanSelected != null) {
      setIsPaymentOpen(!isPaymentOpen);
    }
  };

  const handleCreateSubscription = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const hostname = window.location.hostname;
    const email = cookieService.getCookie('email') || localStorage.getItem('email');
    
    if (isWhitelabel && props.stripeConfig?.monthly_price_id) {
      console.log('Using whitelabel Stripe checkout', props.stripeConfig);
      // Use whitelabel Stripe checkout via mploi-ai backend
      const backendUrl = hostname === 'localhost' 
        ? 'http://localhost:5000' 
        : 'https://ai.mploi.com';
      
      fetch(`${backendUrl}/api/stripe/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          whitelabel_domain: hostname,
          email: email,
          price_id: props.stripeConfig.monthly_price_id,
          success_url: `${window.location.protocol}//${hostname}/ar`,
          cancel_url: `${window.location.protocol}//${hostname}/ar`,
        })
      })
      .then(res => res.json())
      .then(data => {
        if (data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          console.error('Stripe checkout error:', data);
          ValidationErrorToast(data.error || 'Something went wrong while making payment.', 'Payment error');
          setIsSubmitting(false);
        }
      })
      .catch((err) => {
        console.error('Stripe checkout fetch error:', err);
        ValidationErrorToast('Something went wrong while making payment.', 'Payment error');
        setIsSubmitting(false);
      });
    } else {
      // Fallback: original Django subscription endpoint
      api.post(`subscription/`, {
        "product_id": productId,
        "promo_code": couponCodeValue
      })
      .then((data) => {
        if (data.data.checkoutUrl && data.data.checkoutUrl !== undefined && data.data.checkoutUrl !== "") {
          window.location.href = data.data.checkoutUrl;
        } else {
          ValidationErrorToast('Something went wrong while making payment.', 'Payment error');
          setIsSubmitting(false);
        }
      })
      .catch(() => {
        ValidationErrorToast('Something went wrong while making payment.', 'Payment error');
        setIsSubmitting(false);
      });
    }
  }

  const handleDismiss = () => {
    props.setSubsModal(false);
    setCouponCodeValue("");
  };

  const handleLogout = () => {
    userService
      .logout()
      .then(() => {
        cookieService.removeAllCookies();
        window.location.href = "/signin";
      })
      .catch(() => {
        cookieService.removeAllCookies();
        window.location.href = "/signin";
      });
  };

  // Product name: neutral for whitelabel, branded for MPLOI
  const productName = isWhitelabel ? "Invoice Chaser" : "MPLOI Invoice Chaser";
  const productNameMonthly = isWhitelabel ? "Invoice Chaser Monthly" : "MPLOI Invoice Chaser Monthly";

  return (
    <>
      <Modal show={props.subsModal} fullscreen={true} className="subs">
          {subscriptionStep === 2 ?
            <div className="sub-2">
              <div className={isWhitelabel ? "bg-img bg-img-neutral" : "bg-img"} style={isWhitelabel ? { backgroundImage: 'none', backgroundColor: '#1a1a2e' } : {}}>
                <div className="row sub-row">
                  <div className="col-md-2 col-auto">
                    {!isWhitelabel && (
                      <img src={UtilityFunctions.getImageURL() + "logo_White.svg"} />
                    )}
                  </div>
                  <div className="col-md-8 column-three">
                    <div className="title position-relative">
                      <div className="position-absolute subs-image-container ">
                        <img src="/assets/images/arrow-left.png" className="subs-back-arrow" style={{ width: "24px", color: "white", cursor: "pointer" }} onClick={() => {
                          setPromoData(null)
                          setCouponCodeValue("");
                          setSubscriptionStep(1)
                        }} />
                      </div>{productName} Subscription
                    </div>
                    <div className="plan">
                      Start collecting cash from outstanding invoices today.
                    </div>
                  </div>
                  <div
                    className="col-md-1 col-7"
                    style={{ justifyContent: "right", display: "flex", gap: "15px", alignItems: "center" }}
                  >
                    <div
                      style={{ color: "white", fontSize: "14px", cursor: "pointer", textDecoration: "underline", whiteSpace: "nowrap" }}
                      onClick={handleLogout}
                    >
                      Log Out
                    </div>
                    <i
                      className="fa fa-times cross"
                      style={{ color: "white", fontSize: "24px", cursor: "pointer" }}
                      onClick={handleDismiss}
                    ></i>
                  </div>
                </div>
                <div
                  className="selectedSubscription container-fluid "
                  style={{
                    width: "fit-content",
                    height: "fit-content",
                    padding: "20px",
                  }}
                >
                  <div className="d-flex" style={{ justifyContent: "space-between" }}>
                    <div
                      className="type-box"
                      style={{
                        border: "0.897px solid white",
                        background: "transparent",
                        width: "210px",
                        height: "34px",
                      }}
                    >
                      <div style={{ color: "White" }}>{productName}</div>
                    </div>
                    <div className="d-flex" style={{ alignItems: "center" }}>
                    </div>
                  </div>
                  <div
                    className="d-flex main-div"
                  >
                    <div className="col-md-5 col-6 p-0">
                      <div
                        className=" d-flex col-auto mt-3 p-0"
                        style={{
                          justifyContent: "center",
                          alignItems: "baseline",
                          marginLeft: "30px",
                        }}
                      >
                        <div className="price_nav" style={{ textAlign: "inherit" }}>
                          { specificPrice}
                        </div>
                        {specificPrice && <div style={{ color: "#FFFFFF" }}>/month</div>}
                      </div>
                      <div
                        className="subs-year-text"
                        style={{
                          color: "#FFFFFF",
                          fontSize: "12px",
                          marginTop: "10px",
                        }}
                      >
                      </div>
                    </div>
                    <div className="list-add">
                      <div>
                        <div className="row w-100 list-row mt-1">
                          <div className="d-flex align-items-center">
                              <img
                                src="/assets/images/Checkmark.png"
                                className="check"
                                style={{ flexShrink: 0, marginRight: '8px' }}
                              />
                              <div className="list-item">Follow up invoices with AI</div>
                          </div>
                        </div>
                        
                      </div>
                      <div>
                        <div className="row w-100 list-row mt-1">
                          <div className="d-flex align-items-center">
                              <img
                                src="/assets/images/Checkmark.png"
                                className="check"
                                style={{ flexShrink: 0, marginRight: '8px' }}
                              />
                              <div className="list-item">Personalise your agent</div>
                          </div>
                        </div>
                        <div className="row w-100 list-row mt-1">
                          <div className="d-flex align-items-center">
                              <img
                                src="/assets/images/Checkmark.png"
                                className="check"
                                style={{ flexShrink: 0, marginRight: '8px' }}
                              />
                              <div className="list-item">Dedicated mobile number</div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div
                    className="hrcard one"
                    style={{ marginLeft: "-15px", width: "244px", position: "absolute", bottom: "0px" }}
                  ></div>
                </div>
                <div className="container-fluid margn-top38">
                  <div
                    className="navSubscription container-fluid"
                    style={{ width: "409px" }}
                  >
                    <div className="heading">Price Details</div>
                    <div style={{ padding: "10px 10px" }}>
                      <div className="price-details">
                        <div className="price-details-text">
                          {productNameMonthly}
                        </div>
                        <div className="price-details-text">{specificPrice ? `${specificPrice} / month` : 'Monthly subscription'}</div>
                      </div>
                      {showSpecialDiscount && specialDiscountAmount && specialDiscountSource && (
                        <div className="price-details">
                          <div className="price-details-text">
                            Special Discount
                          </div>
                          <div className="price-details-text" style={{ color: isWhitelabel ? "#4fc3f7" : "#06EFC5" }}>
                            -${specialDiscountAmount} courtesy of {specialDiscountSource}
                          </div>
                        </div>
                      )}
                      <div className="price-details">
                        <div
                          className="price-details-text"
                          style={{ fontWeight: "500" }}
                        >
                          Pay
                        </div>
                        <div
                          className="price-details-text"
                          style={{ fontWeight: "500" }}
                        >
                          { specificPrice || 'See checkout' }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="mt-4"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div>
                      <div className="d-flex" style={{ width: "fit-content", margin: "0px auto", alignItems: "center" }}>
                        {promoData && <>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8.74905 5.50003C8.74905 5.91371 8.41369 6.24907 8.00001 6.24907C7.58633 6.24907 7.25098 5.91371 7.25098 5.50003C7.25098 5.08635 7.58633 4.751 8.00001 4.751C8.41369 4.751 8.74905 5.08635 8.74905 5.50003ZM8 7C8.27614 7 8.5 7.22386 8.5 7.5V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V7.5C7.5 7.22386 7.72386 7 8 7Z"
                              fill={isWhitelabel ? "#4fc3f7" : "#06EFC5"}
                            />
                          </svg>

                          <div style={{ color: isWhitelabel ? "#4fc3f7" : "#06EFC5", fontSize: "12px", paddingLeft: "5px" }}>
                            You are saving ${promoData?.price?.discountAmount}.
                          </div>
                        </>
                        }
                      </div>

                      <div 
                        className="btn-continue mt-1" 
                        style={{ 
                          width: "350px",
                          ...(isWhitelabel ? { background: '#4fc3f7' } : {}),
                          ...(isSubmitting ? { opacity: 0.6, pointerEvents: 'none' as const } : {})
                        }} 
                        onClick={() => handlePaymentOption()} 
                      >
                        <div className="cont">{isSubmitting ? 'Processing...' : `Pay ${specificPrice || ''}`}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : ""}
        {isPaymentOpen ?
          <div style={{ width: "100vw", height: "100%" }} className=" container-fluid position-absolute outer_container" onClick={() => handlePayment()}>
            <div className=" d-flex align-items-center justify-content-center" style={{ width: "100vw", height: "100vh" }}>
              <PaymentProcedure
                isCardAdded={isCardAdded}
                productId={productId}
                couponCodeValue={couponCodeValue}
              />
            </div>
          </div>
          :
          null}
      </Modal >
    </>
  );
};

export default SubscriptionModalAccounts;
